import React, { Component } from 'react'
import cx from 'classnames'

import './cookie-consent.scss'

export default class CookieConsent extends Component {

    state = {
        expanded: false,
        secondsBeforeShow: 1.5
    }

    componentDidMount () {

        const hasConsented = window.localStorage.getItem('cookie-consent')

        if (hasConsented === 'false') {
            this.setState({ expanded: false })
        }

        if (!hasConsented) {
            const showTimeout = setTimeout(() => {
                this.setState({ expanded: true })
                clearTimeout(showTimeout)
            }, this.state.secondsBeforeShow * 1000)
        }

        document.body.addEventListener('opt-out-analytics', e => {
            this.setState({ expanded: false })
        })
    }

    onClick = e => {
        this.setState({ expanded: false })
        window.localStorage.setItem('cookie-consent', 'true')
    }

    render () {

        const className = cx(
            'cookie-consent',
            { expanded: this.state.expanded }
        )

        return (
            <div className={className}>
                <div>
                    We use cookies to analyze the traffic to this directory.
                    <br />
                    Information about your use of our directory is shared with Google for that purpose.
                </div>
                <div>
                    <button onClick={this.onClick}>OK, got it</button>
                    <a href="/privacy-policy" target="_blank">Data Protection</a>
                </div>
            </div>
        )

    }

}


// WEBPACK FOOTER //
// ./src/components/shared/cookie-consent/index.jsx